if (!customElements.get('recipient-form')) {
  customElements.define(
    'recipient-form',
    class RecipientForm extends HTMLElement {
      constructor() {
        super();
        this.checkboxInput = this.querySelector(`#Recipient-checkbox-${this.dataset.sectionId}`);
        this.hiddenControlField = this.querySelector(`#Recipient-control-${this.dataset.sectionId}`);
        this.emailInput = this.querySelector(`#Recipient-email-${this.dataset.sectionId}`);
        this.nameInput = this.querySelector(`#Recipient-name-${this.dataset.sectionId}`);
        this.messageInput = this.querySelector(`#Recipient-message-${this.dataset.sectionId}`);
        this.sendonInput = this.querySelector(`#Recipient-send-on-${this.dataset.sectionId}`);
        this.offsetProperty = this.querySelector(`#Recipient-timezone-offset-${this.dataset.sectionId}`);
        this.recipientFieldsLiveRegion = this.querySelector(
          `#Recipient-fields-live-region-${this.dataset.sectionId}`
        );
        this.errorMessageWrapper = this.querySelector('.product-form__recipient-error-message-wrapper');

        if (this.offsetProperty) {
          this.offsetProperty.value = new Date().getTimezoneOffset().toString();
        }

        if (this.checkboxInput) {
          this.checkboxInput.disabled = false;
        }
        if (this.hiddenControlField) {
          this.hiddenControlField.disabled = true;
        }

        this.addEventListener('change', this.onChange.bind(this));
        this.onChange();
      }

      onChange() {
        if (!this.checkboxInput) return;

        if (this.checkboxInput.checked) {
          this.enableInputFields();
          if (this.recipientFieldsLiveRegion && window.accessibilityStrings?.recipientFormExpanded) {
            this.recipientFieldsLiveRegion.innerText = window.accessibilityStrings.recipientFormExpanded;
          }
        } else {
          this.clearInputFields();
          this.disableInputFields();
          this.clearErrorMessage();
          if (this.recipientFieldsLiveRegion && window.accessibilityStrings?.recipientFormCollapsed) {
            this.recipientFieldsLiveRegion.innerText = window.accessibilityStrings.recipientFormCollapsed;
          }
        }
      }

      inputFields() {
        return [this.emailInput, this.nameInput, this.messageInput, this.sendonInput].filter(Boolean);
      }

      disableableFields() {
        return [...this.inputFields(), this.offsetProperty].filter(Boolean);
      }

      clearInputFields() {
        this.inputFields().forEach((field) => {
          field.value = '';
        });
      }

      enableInputFields() {
        this.disableableFields().forEach((field) => {
          field.disabled = false;
        });
      }

      disableInputFields() {
        this.disableableFields().forEach((field) => {
          field.disabled = true;
        });
      }

      clearErrorMessage() {
        if (this.errorMessageWrapper) {
          this.errorMessageWrapper.hidden = true;
        }

        this.querySelectorAll('.recipient-fields .form__message').forEach((field) => {
          field.classList.add('hidden');
          const textField = field.querySelector('.error-message');
          if (textField) textField.innerText = '';
        });

        this.inputFields().forEach((inputElement) => {
          inputElement.setAttribute('aria-invalid', false);
          inputElement.removeAttribute('aria-describedby');
        });
      }
    }
  );
}
